import { Component, ErrorInfo, ReactNode } from "react";

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
}

export class RootErrorBoundary extends Component<Props, State> {
  public state: State = { hasError: false };

  public static getDerivedStateFromError(): Partial<State> {
    return { hasError: true };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    // TODO: Send to error monitoring service (e.g. Sentry)
    console.error("Root ErrorBoundary caught an error:", error, errorInfo);
  }

  private handleReload = () => {
    window.location.reload();
  };

  public render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            minHeight: "100vh",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            fontFamily: "'DM Sans', system-ui, -apple-system, sans-serif",
            background: "hsl(120 20% 98%)",
            color: "hsl(150 25% 15%)",
            padding: "2rem",
            textAlign: "center",
          }}
        >
          <h1
            style={{
              fontSize: "1.5rem",
              fontWeight: 700,
              marginBottom: "0.75rem",
              fontFamily: "'Plus Jakarta Sans', system-ui, sans-serif",
            }}
          >
            Something went wrong
          </h1>
          <p
            style={{
              fontSize: "1.125rem",
              color: "hsl(150 15% 45%)",
              marginBottom: "1.5rem",
              maxWidth: "480px",
            }}
          >
            We're sorry, an unexpected error occurred. Please try reloading the page.
          </p>
          <button
            onClick={this.handleReload}
            style={{
              background: "hsl(153 40% 30%)",
              color: "#fff",
              padding: "0.75rem 1.5rem",
              borderRadius: "0.5rem",
              border: "none",
              fontSize: "1rem",
              fontWeight: 600,
              cursor: "pointer",
            }}
          >
            Reload Page
          </button>
          <a
            href="tel:01202509592"
            style={{
              marginTop: "1rem",
              color: "hsl(153 40% 30%)",
              fontSize: "0.95rem",
            }}
          >
            Or call us: 01202 509 592
          </a>
        </div>
      );
    }

    return this.props.children;
  }
}
